import { DirectIFramelessEmbedStrategy, type EmbedHooks } from '@source-digital/embed-core'
import { DirectEmbedStrategy } from '@source-digital/embed-core'
import '@source-digital/embed-core/dist/assets/vue-direct-renderer.css'

export const directStrategyPlugin: EmbedHooks = {
  onEmbedderCreate (context) {
    context.embedStrategyFactoryRegistry.register('direct', {
      create (target) {
        return new DirectEmbedStrategy(target)
      }
    })
    context.embedStrategyFactoryRegistry.register('direct-iframeless', {
      create (target) {
        return new DirectIFramelessEmbedStrategy(target)
      }
    })
    context.embedStrategyFactoryRegistry.register('direct-with-iframe', {
      create (target) {
        return new DirectEmbedStrategy(target)
      }
    })
  }
}
